import React from 'react';
import PropTypes from 'prop-types';
import Lang from '../../language/services/Lang'
import HrbTranslate from '../../language/HrbTranslate';

const HelpLink = (props) => (
        <a href={Lang.getCurrentValue('App.HelpLinkBase') + (props.helpKey || '')} target='_blank' rel='noopener noreferrer'>
            <HrbTranslate text={props.textKey?props.textKey:'App.HelpLinkText'} />
        </a>
);

HelpLink.propTypes = {
    helpKey: PropTypes.string.isRequired,
    textKey: PropTypes.string
}

export default HelpLink;